import { ListingDetailPage } from "../pages/ListingDetailPage";

export const Dashboard = () => {
  return <ListingDetailPage listingId="dream_services_directory" />;
};
